import {
  Box,
  Center,
  FormControl,
  Input,
  Divider,
  Text,
  HStack,
  InputRightElement,
  Spacer,
  Flex,
} from "@chakra-ui/react";
import { FiSend } from "react-icons/fi";
import { Icon } from "@chakra-ui/react";
import React, { useState, useEffect, useRef } from "react";
import { socket } from "./service/socket";
import ColorPicker from "./components/ColorPicker";

function App({ usr, room }) {
  const chatBox = useRef();
  const username = useRef();
  //const [usr, setusr] = useState("");
  const [data, setdata] = useState([]);
  const [inputVal, setinputVal] = useState("");
  const [isWriting, setisWriting] = useState(false);

  //=========================================
  useEffect(() => {
    chatBox.current.scrollTop = chatBox.current.scrollHeight;
  });

  useEffect(() => {
    setdata([]);
  }, [room]);
  // on sublit function ======================

  const onSubmitFunc = (e) => {
    e.preventDefault();
    const da =
      new Date().getHours() +
      ":" +
      new Date().getMinutes() +
      ":" +
      new Date().getSeconds();

    setdata((prev) => [
      ...prev,
      {
        sender: "YOU",
        message: inputVal,
        date: da,
        messagePos: "flex-end",
        messageColor: "blue.300",
      },
    ]);
    setinputVal("");

    socket.emit("chat message", {
      sender: usr,
      message: inputVal,
      room: room,
    });
  };

  //=========================================
  useEffect(() => {
    //  username.current.focus();
    socket.on("message", (msg) => {
      const date =
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      console.log("message: " + JSON.stringify(msg));
      const mm = { ...msg, date };
      //  const messagePos = "flex-end";

      setdata((prev) => [...prev, mm]);
      var audio = new Audio(
        "https://www.myinstants.com/media/sounds/facebook-chat-sound-hd.mp3"
      );
      audio.play();
      //console.log([{ ...mm, da }]);
    });
  }, []);

  // ==========================================
  useEffect(() => {
    if (inputVal.length > 0) {
      // console.log("rani fel 1");
      socket.emit("is writing", { is: true, room: room });
    } else {
      socket.emit("is writing", { is: false, room: room });
    }
  }, [inputVal]);

  //============================================
  useEffect(() => {
    socket.on("isWriting", (ll) => {
      console.log("is writing");
      console.log(ll);
      if (ll) {
        setisWriting(true);
      } else {
        setisWriting(false);
      }
    });
  }, []);
  //===============================================

  return (
    <Center w="100%" h="85vh">
      <Box
        w={{ base: "99%", md: "100%" }}
        //  border="1px solid grey"
        //  boxShadow="dark-lg"
        // bg="red"
        h="100%"
        // rounded={5}
        //        <p>{room}</p>

        p={4}
        color="white"
      >
        <Box
          ref={chatBox}
          h="90%"
          overflowY="scroll"
          width="100%"
          style={{
            scrollbarColor: "transparent transparent",
          }}
        >
          {data.map((item, index) => {
            return (
              <div key={index}>
                <Box
                  w="100%"
                  color="black"
                  //    bg="red"
                  p={5}
                  display="flex"
                  //  alignItems="center"

                  justifyContent={item.messagePos}
                >
                  <Box
                    bg={item.messageColor ? item.messageColor : "crimson"}
                    w={{ base: "80%", lg: "50%" }}
                    rounded={20}
                    p={5}
                  >
                    <HStack>
                      <Text color="white" pl={2} pr={2}>
                        {" "}
                        {item.sender}
                      </Text>{" "}
                      <Spacer />
                      <Text color="blue.100" pl={2}>
                        {" "}
                        {item.date}
                      </Text>
                    </HStack>

                    <Box ml={10} mt={5} color="white">
                      {" "}
                      {item.message}
                    </Box>
                  </Box>
                </Box>
                <Divider />
              </div>
            );
          })}
        </Box>
        <Divider />
        <Box h="10%">
          <form onSubmit={onSubmitFunc}>
            <FormControl id="message">
              <Input
                //  boxShadow="dark-lg"
                _focus={{ border: "none" }}
                border="none"
                placeholder="Send Hi to other users"
                color="black"
                type="text"
                value={inputVal}
                onChange={(event) => setinputVal(event.target.value)}
              />
              <InputRightElement
                h="100%"
                mr={5}
                children={
                  <Icon
                    as={FiSend}
                    color="blue.200"
                    w={6}
                    h={6}
                    onClick={onSubmitFunc}
                  />
                }
              />
            </FormControl>
          </form>

          {isWriting && <Box color="black">someone is writing</Box>}
        </Box>
      </Box>
    </Center>
  );
}

export default App;
